import {clickEvent, customDocumentEvent, customEvent} from "../../../../webpack/modules/events";
import {isDesktop} from "../../../../webpack/modules/devices";
import {hideOffcanvasByDomObject} from "../../../../webpack/modules-optimized/offcanvas";
import {fadeOut} from "../../../../webpack/modules-optimized/element-visibility";
import {
    addToCart,
    addToCartMultiSize, goToConfiguration,
    updateConfigurationButtons,
    updateConfigurationStepPoints
} from "../../../../webpack/modules-optimized/product-list";
import {ga4TrackSimpleEvent} from "../../../../webpack/modules/analytics";

clickEvent('#product-list-page .product-configuration .open-configuration', true, function(element) {
    let container = document.querySelector('#product-list-page');
    let type = element.dataset.type;
    let configurationContainer = isDesktop() ? container.querySelector(`.desktop-product-configuration.product-configuration-${type}`) : container.querySelector(`.mobile-product-configuration.product-configuration-${type}`);
    let currentConfigurationContainer = container.querySelector('.product-configuration.open');

    goToConfiguration(currentConfigurationContainer, configurationContainer);
});

clickEvent('#product-list-page .product-configuration .close-product-configuration', true, function(element) {
    let configuration = element.closest('.product-configuration');

    if (isDesktop()) fadeOut(configuration);
    else hideOffcanvasByDomObject(configuration);
    configuration.classList.remove('open');
    ga4TrackSimpleEvent({
        event: 'quick_purchase',
        method: 'close'
    });
});

clickEvent('#product-list-page .product-configuration .back-button-product-configuration', true, async function(element) {
    let currentConfiguration = element.closest('.product-configuration');
    let currentConfigurationNumber = parseInt(currentConfiguration.dataset.configurationNumber);
    let nextConfiguration = isDesktop() ? element.closest('.product').querySelector(`.product-configuration[data-configuration-number="${currentConfigurationNumber - 1}"]`) : document.querySelector(`#product-list-page .offcanvas.product-configuration[data-configuration-number="${currentConfigurationNumber - 1}"]`) ;

    if (currentConfigurationNumber === 1) {
        nextConfiguration = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    }

    goToConfiguration(currentConfiguration, nextConfiguration);
});

customEvent('hidden.bs.offcanvas', '#product-list-page .product-configuration', true, function(configuration) {
    configuration.classList.remove('open');
});

customEvent('shown.bs.offcanvas', '#product-list-page .product-configuration', true, function() {
    document.querySelectorAll('#product-list-page .offcanvas.product-configuration').forEach(function(configuration) {
        if (configuration.classList.contains('offcanvas-end')) configuration.classList.remove('offcanvas-end');
        if (!configuration.classList.contains('offcanvas-bottom')) configuration.classList.add('offcanvas-bottom');
    });
});

clickEvent('#product-list-page .product-configuration .continue-configuration', true, async function(element) {
    let currentConfiguration = element.closest('.product-configuration');
    let nextConfiguration = document.querySelector('#product-list-page .product-configuration[data-completed="false"]:not(.product-configuration-main)');

    goToConfiguration(currentConfiguration, nextConfiguration);
});

customDocumentEvent('productListProductConfigurationChanged', function() {
    updateConfigurationStepPoints();
    updateConfigurationButtons();
});

clickEvent('#product-list-page .product-configuration .btn-add-to-cart', true, function(button) {
    let mainContainer = isDesktop() ? button.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let inputSizes = mainContainer.querySelector('input[name="option-size"]');
    let sizes = inputSizes && inputSizes.value !== '' ? JSON.parse(inputSizes.value) : [];

    if (sizes.length > 1) addToCartMultiSize(mainContainer);
    else addToCart(mainContainer);
});

